import { createRequest, axios, defaultcancelRefer, Error } from './lube/RequestFactory';
import {
    getEnv,
    getPokeUser,
    getH5ParametersDict,
    getH5Parameters,
    isIos,
    isNative,
    getWebUniqueDeviceId
} from './utils.js';
import { bridge } from './bridge.js';
import { Performance } from './Performance.js';
import { BOM } from './BOM.js';
import { reportException } from './monitor.js';
import { isWebPageFileOpen } from './lube/Utils';
//
const apiBlockCollection = {
    '/x/mv/info': '/x/mv/simple_info'
};
const _env = getEnv();
const pokeUser = getPokeUser();
const isTestEnv = window.location.host.indexOf('test.pokekara.com') != -1;
const _parametersDict = getH5ParametersDict();
let _parameters = getH5Parameters();
//web 请求加入 unique_device_id
if (!isNative()) {
    const uniqueDeviceId = getWebUniqueDeviceId();
    if (uniqueDeviceId && !_parametersDict['unique_device_id']) {
        _parametersDict['unique_device_id'] = uniqueDeviceId;
        _parameters = _parameters + '&unique_device_id=' + uniqueDeviceId;
    }
}

//
function _log(data) {
    data && (data.type = 'error') && (data.event = Error.EVENT);
    Performance.log(data);
}

function isDebug() {
    return pokeUser.is_debug || false;
}

function debugResponse(url, response) {
    if (isDebug()) {
        //response 上报给客户端，用于测试抓包
        bridge.post('debug_api_response', {
            url: url,
            response: response
        });
    }
}

function debugRequest(url) {
    if (isDebug()) {
        //request 上报给客户端，用于测试抓包
        bridge.post('debug_api_request', {
            url: url
        });
    }
}

function handleRequestHeader(headers) {
    if (pokeUser.poke_session_id) {
        headers['x-poke-session-id'] = pokeUser.poke_session_id;
    }
}

//
const _request = createRequest({
    baseUrl: 'https://api.pokekara.com',
    testBaseUrl: 'https://test.api.pokekara.com',
    mockBaseUrl: 'http://test.pokekara.com',
    isTestEnv: isTestEnv,
    env: _env,
    sendLog: _log,
    debugRequest: debugRequest,
    debugResponse: debugResponse,
    logException: reportException,
    isNative: isNative(),
    allowNativeRequest: pokeUser.allows_native_request,
    apiBlockCollection: apiBlockCollection,
    handleRequestHeader: handleRequestHeader,
    parametersDict: _parametersDict,
    parameters: _parameters
});


/*
 * runScript：一个promise同步方法。可以代替创建一个script标签，然后加载服务
 * */
const runScript = async url => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = resolve;
        script.onerror = reject;
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);
    });
};
//
const getManifest = (url, bundle = 'main', host = '') =>
    new Promise(async (resolve, reject) => {
        const { data } = await axios.get(url + '?timestamp=' + Date.now(), {
            withCredentials: false
        }).catch(() => {
            reject();
        });
        const { entrypoints, publicPath } = data;
        const startsWithHttp = /^https?:\/\/.*/.test(publicPath);
        host = startsWithHttp ? '' : host;
        if (entrypoints) {
            const assets = entrypoints[bundle].assets.filter(asset => asset.indexOf('.map') === -1);
            for (let i = 0; i < assets.length; i++) {
                await runScript(`${host}${publicPath}${assets[i]}`).then(() => {
                    if (i === assets.length - 1) {
                        resolve();
                    }
                });
            }
        } else {
            reject();
        }
    });

async function loadVueComponents(projectName, path, host = '') {
    try {
        await getManifest(path, 'main', host);
        const components = BOM.window[projectName];
        if (components) {
            return components;
        } else {
            return null;
        }

    } catch (e) {
        BOM.log(e);
        return null;
        //
    }
}

function getImageArrayBuffer(url){
    let _url = url;
    if(isWebPageFileOpen()){
        _url = "pzipf://p.c" + url.substring(1);
    }
    return new BOM.window.Promise((resolve)=>{
        const xhr = new XMLHttpRequest();
        xhr.open('GET', _url, true);
        xhr.responseType = 'arraybuffer';
        xhr.onload = () => {
            resolve(xhr.response);
        };
        xhr.send(null);
    })
}


export { _request as request, axios, defaultcancelRefer, Error, getManifest, loadVueComponents, getImageArrayBuffer };
